import apiCourier from '@/api/ecommerce/courier';

const defaultState = () => ({
	listCourier: [],
	paginationCourier: '',
});

const state = defaultState();

const getters = {

};

const mutations = {
	setCourier(state, data) {
		state.listCourier = data.data
		state.paginationCourier = data.pagination;
	},
	clearDataCourier(state) {
		Object.assign(state, defaultState())
	}
};

const actions = {
	getCourier({ commit, dispatch }, params) {
		apiCourier.getDataCourier(params).then(({ data: { data } }) => {
			commit('setCourier', { data: data.results, pagination: data.pagination });
		}).catch((err) => {
			commit('setCourier', { data: [], pagination: {} });
			const data = err.response.data
			dispatch("errorHandler", data, { root: true })
		});
	},
	async exportCourier({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiCourier.exportCourier(params).then(({ data: { data } }) => {
			dispatch('success', data.results.message, { root: true })
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data Kurir'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async addCourier({ dispatch }, params) {
		await dispatch('isAttempting', null, { root: true })
		await apiCourier.addCourier(params).then(res => {
			const data = res.data;
			dispatch('success', data.message, { root: true })
		}).catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data, { root: true })
		});
		await dispatch('attempted', null, { root: true })
	},
	async updateCourier({ dispatch }, params) {
		await dispatch('isAttempting', null, { root: true })
		await apiCourier.updateCourier(params).then(res => {
			const data = res.data;
			dispatch('success', data.message, { root: true })
		}).catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data, { root: true })
		});
		await dispatch('attempted', null, { root: true })
	},
	async deleteCourier({ dispatch }, params) {
		await dispatch('isAttempting', null, { root: true })
		await apiCourier.deleteCourier(params).then(res => {
			const data = res.data;
			dispatch('success', data.message, { root: true })
		}).catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data, { root: true })
		});
		await dispatch('attempted', null, { root: true })
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};